export class Period {
    fromDate: Date;
    toDate: Date;
    name: string;

    constructor(fromDate: Date, toDate: Date, name: string) {
        this.fromDate = fromDate;
        this.toDate = toDate;
        this.name = name;
    }
}
